(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ingredientsci-prod"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.ingredientsci-prod-{{ section.id }}';
    const sectionId = '{{ section.id }}';
    let teardown = null;

    const mount = () => {
      const section = document.querySelector(sectionSelector);
      if (!section) return;

      if (teardown) teardown();

      const wrapper = section.querySelector('.ingredientsci-prod-{{ section.id }}__slider-scroll');
      const track = section.querySelector('.ingredientsci-prod-{{ section.id }}__track');
      const prevButton = section.querySelector('.ingredientsci-prod-{{ section.id }}__slider-nav-btn--prev');
      const nextButton = section.querySelector('.ingredientsci-prod-{{ section.id }}__slider-nav-btn--next');
      if (!wrapper || !track) return;

      const removeHandlers = [];
      const bind = (target, eventName, handler, options) => {
        target.addEventListener(eventName, handler, options);
        removeHandlers.push(() => target.removeEventListener(eventName, handler, options));
      };

      let hasInitializedPosition = false;

      const alignToRight = () => {
        if (!hasInitializedPosition) {
          wrapper.scrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
          hasInitializedPosition = true;
        }
      };

      const getTierConfig = () => {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= 1200) return { baseEndGutter: 184, desiredRightGap: 60, maxEndGutter: 1200 };
        if (viewportWidth >= 990) return { baseEndGutter: 132, desiredRightGap: 48, maxEndGutter: 900 };
        if (viewportWidth >= 750) return { baseEndGutter: 92, desiredRightGap: 40, maxEndGutter: 640 };
        return { baseEndGutter: 24, desiredRightGap: 24, maxEndGutter: 320 };
      };

      const getVisibleBounds = () => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const viewportLeft = 0;
        const viewportRight = window.innerWidth || document.documentElement.clientWidth;
        let visibleLeft = Math.max(wrapperRect.left, viewportLeft);
        let visibleRight = Math.min(wrapperRect.right, viewportRight);
        let node = wrapper.parentElement;

        while (node && node !== document.body) {
          const nodeStyles = window.getComputedStyle(node);
          if (nodeStyles.overflowX === 'hidden' || nodeStyles.overflowX === 'clip') {
            const nodeRect = node.getBoundingClientRect();
            visibleLeft = Math.max(visibleLeft, nodeRect.left);
            visibleRight = Math.min(visibleRight, nodeRect.right);
          }
          node = node.parentElement;
        }

        const clipLeftDelta = Math.max(0, visibleLeft - wrapperRect.left);
        const clipRightDelta = Math.max(clipLeftDelta, visibleRight - wrapperRect.left);
        return { clipLeftDelta, clipRightDelta };
      };

      const getLastCardMetrics = () => {
        const lastCard = track.querySelector('.ingredientsci-prod-{{ section.id }}__card:last-of-type');
        if (!lastCard) return null;
        const trackOffset = track.offsetLeft;
        const cardLeft = lastCard.offsetLeft - trackOffset;
        const cardRight = cardLeft + lastCard.offsetWidth;
        return { cardLeft, cardRight };
      };

      const getEndTargetLeft = (desiredRightGap) => {
        const metrics = getLastCardMetrics();
        if (!metrics) return 0;
        const { clipRightDelta } = getVisibleBounds();
        return Math.max(0, Math.ceil(metrics.cardRight + desiredRightGap - clipRightDelta));
      };

      const calibrateEndGutter = () => {
        const tier = getTierConfig();
        let tunedEndGutter = tier.baseEndGutter;
        let attempts = 0;

        while (attempts < 4) {
          section.style.setProperty('--ingredientsci-end-gutter', `${tunedEndGutter}px`);
          void wrapper.offsetWidth;

          const requiredEndTarget = getEndTargetLeft(tier.desiredRightGap);
          const maxScrollLeft = Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
          const deficit = Math.ceil(requiredEndTarget - maxScrollLeft);

          if (deficit <= 0) break;

          tunedEndGutter = Math.min(tunedEndGutter + deficit + 8, tier.maxEndGutter);
          attempts += 1;
        }

        section.style.setProperty('--ingredientsci-end-gutter', `${tunedEndGutter}px`);
      };

      const cardSelector = '.ingredientsci-prod-{{ section.id }}__card';
      let snapPoints = [];
      let isMouseDragging = false;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let hasDragged = false;
      let suppressClick = false;

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const getMaxScrollLeft = () => Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);

      const collectSnapPoints = () => {
        const trackOffset = track.offsetLeft;
        return Array.from(track.querySelectorAll(cardSelector)).map((card) =>
          Math.round(card.offsetLeft - trackOffset)
        );
      };

      const getNearestIndex = () => {
        if (!snapPoints.length) return 0;
        const currentLeft = wrapper.scrollLeft;
        let nearestIndex = 0;
        let nearestDistance = Math.abs(snapPoints[0] - currentLeft);

        snapPoints.forEach((point, index) => {
          const distance = Math.abs(point - currentLeft);
          if (distance < nearestDistance) {
            nearestIndex = index;
            nearestDistance = distance;
          }
        });

        return nearestIndex;
      };

      const usesMobileStepNavigation = () => window.matchMedia('(max-width: 989px)').matches;

      const getAdjacentStepIndex = (direction) => {
        if (!snapPoints.length) return 0;
        const currentLeft = wrapper.scrollLeft;
        const tolerance = 6;

        if (direction > 0) {
          for (let index = 0; index < snapPoints.length; index += 1) {
            if (snapPoints[index] > currentLeft + tolerance) return index;
          }
          return snapPoints.length - 1;
        }

        for (let index = snapPoints.length - 1; index >= 0; index -= 1) {
          if (snapPoints[index] < currentLeft - tolerance) return index;
        }
        return 0;
      };

      const updateNavState = () => {
        const tolerance = 6;

        if (usesEdgeNavigation()) {
          const maxScrollLeft = getMaxScrollLeft();
          if (prevButton) prevButton.disabled = wrapper.scrollLeft <= tolerance;
          if (nextButton) nextButton.disabled = wrapper.scrollLeft >= maxScrollLeft - tolerance;
          return;
        }

        if (!snapPoints.length) return;
        const index = getNearestIndex();
        if (prevButton) prevButton.disabled = index <= 0;
        if (nextButton) nextButton.disabled = index >= snapPoints.length - 1;
      };

      const usesEdgeNavigation = () => window.matchMedia('(min-width: 990px)').matches;

      const applySnapModeForTier = () => {
        if (usesEdgeNavigation()) {
          wrapper.style.scrollSnapType = 'x proximity';
          return;
        }
        wrapper.style.scrollSnapType = '';
      };

      const forceEdge = (toEnd) => {
        const previousSnapType = wrapper.style.scrollSnapType;
        wrapper.style.scrollSnapType = 'none';

        // Force layout so end-gutter CSS changes are reflected before jump.
        void wrapper.offsetWidth;

        const tier = getTierConfig();
        const targetLeft = toEnd
          ? clamp(getEndTargetLeft(tier.desiredRightGap), 0, getMaxScrollLeft())
          : 0;
        wrapper.scrollLeft = targetLeft;

        requestAnimationFrame(() => {
          const confirmedTargetLeft = toEnd
            ? clamp(getEndTargetLeft(tier.desiredRightGap), 0, getMaxScrollLeft())
            : 0;
          wrapper.scrollLeft = confirmedTargetLeft;
          wrapper.style.scrollSnapType = usesEdgeNavigation() ? 'x proximity' : previousSnapType;
          updateNavState();
        });
      };

      const scrollToIndex = (index) => {
        if (!snapPoints.length) return;
        const boundedIndex = clamp(index, 0, snapPoints.length - 1);
        const targetLeft = clamp(snapPoints[boundedIndex], 0, getMaxScrollLeft());
        wrapper.scrollTo({ left: targetLeft, behavior: 'smooth' });
        requestAnimationFrame(updateNavState);
      };

      const onPrevArrowClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        if (usesEdgeNavigation()) {
          forceEdge(false);
          requestAnimationFrame(() => {
            forceEdge(false);
          });
        } else {
          if (!snapPoints.length) return;
          if (usesMobileStepNavigation()) {
            scrollToIndex(getAdjacentStepIndex(-1));
          } else {
            scrollToIndex(getNearestIndex() - 1);
          }
        }
      };

      const onNextArrowClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        if (usesEdgeNavigation()) {
          calibrateEndGutter();
          forceEdge(true);
          requestAnimationFrame(() => {
            calibrateEndGutter();
            forceEdge(true);
            requestAnimationFrame(() => {
              forceEdge(true);
            });
          });
        } else {
          if (!snapPoints.length) return;
          if (usesMobileStepNavigation()) {
            scrollToIndex(getAdjacentStepIndex(1));
          } else {
            scrollToIndex(getNearestIndex() + 1);
          }
        }
      };

      const endMouseDrag = (shouldSnap = true) => {
        if (!isMouseDragging) return;
        isMouseDragging = false;
        dragPointerId = null;
        wrapper.classList.remove('is-dragging');

        if (shouldSnap && hasDragged) {
          scrollToIndex(getNearestIndex());
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }

        hasDragged = false;
        requestAnimationFrame(updateNavState);
      };

      const initializeLayout = () => {
        hasInitializedPosition = false;
        applySnapModeForTier();
        calibrateEndGutter();
        requestAnimationFrame(() => {
          alignToRight();
          snapPoints = collectSnapPoints();
          updateNavState();
          requestAnimationFrame(() => {
            alignToRight();
            snapPoints = collectSnapPoints();
            updateNavState();
          });
        });
      };

      wrapper.querySelectorAll('img').forEach((image) => {
        image.setAttribute('draggable', 'false');
      });

      const syncNavState = () => {
        requestAnimationFrame(updateNavState);
      };

      const onPointerDown = (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        isMouseDragging = true;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScrollLeft = wrapper.scrollLeft;
        hasDragged = false;
        wrapper.classList.add('is-dragging');
      };

      const onPointerMove = (event) => {
        if (!isMouseDragging || event.pointerId !== dragPointerId) return;

        const deltaX = event.clientX - dragStartX;
        if (Math.abs(deltaX) > 3) hasDragged = true;

        wrapper.scrollLeft = dragStartScrollLeft - deltaX;
        if (hasDragged) event.preventDefault();
        syncNavState();
      };

      const onPointerUp = (event) => {
        if (!isMouseDragging || event.pointerId !== dragPointerId) return;
        endMouseDrag(true);
      };

      const onPointerCancel = (event) => {
        if (!isMouseDragging || event.pointerId !== dragPointerId) return;
        endMouseDrag(false);
      };

      const onClickCapture = (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      };

      const preventNativeDrag = (event) => {
        event.preventDefault();
      };

      initializeLayout();
      bind(window, 'resize', initializeLayout);
      bind(wrapper, 'scroll', syncNavState, { passive: true });
      bind(wrapper, 'wheel', syncNavState, { passive: true });
      bind(wrapper, 'touchmove', syncNavState, { passive: true });
      bind(wrapper, 'pointerdown', onPointerDown);
      bind(window, 'pointermove', onPointerMove);
      bind(window, 'pointerup', onPointerUp);
      bind(window, 'pointercancel', onPointerCancel);
      bind(wrapper, 'click', onClickCapture, true);
      bind(wrapper, 'dragstart', preventNativeDrag);
      if (prevButton) bind(prevButton, 'click', onPrevArrowClick, true);
      if (nextButton) bind(nextButton, 'click', onNextArrowClick, true);

      track.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', initializeLayout, { once: true });
      });

      teardown = () => {
        removeHandlers.forEach((removeListener) => removeListener());
        teardown = null;
      };
    };

    mount();

    document.addEventListener('shopify:section:load', (event) => {
      if (String(event.detail && event.detail.sectionId) !== sectionId) return;
      mount();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (String(event.detail && event.detail.sectionId) !== sectionId) return;
      if (teardown) teardown();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Lifestyle-prod"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.lifestyle-prod-{{ section.id }}';
    const sectionId = '{{ section.id }}';
    let teardown = null;

    const mount = () => {
      const section = document.querySelector(sectionSelector);
      if (!section) return;

      if (teardown) teardown();

      const wrapper = section.querySelector('.lifestyle-prod-{{ section.id }}__slider-scroll');
      const track = section.querySelector('.lifestyle-prod-{{ section.id }}__track');
      const prevButton = section.querySelector('.lifestyle-prod-{{ section.id }}__slider-nav-btn--prev');
      const nextButton = section.querySelector('.lifestyle-prod-{{ section.id }}__slider-nav-btn--next');
      if (!wrapper || !track) return;

      const removeHandlers = [];
      const bind = (target, eventName, handler, options) => {
        target.addEventListener(eventName, handler, options);
        removeHandlers.push(() => target.removeEventListener(eventName, handler, options));
      };

      let hasInitializedPosition = false;
      const alignToRight = () => {
        if (!hasInitializedPosition) {
          wrapper.scrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
          hasInitializedPosition = true;
        }
      };

      const getTierConfig = () => {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= 1200) return { baseEndGutter: 184, desiredRightGap: 60, maxEndGutter: 1200 };
        if (viewportWidth >= 990) return { baseEndGutter: 132, desiredRightGap: 48, maxEndGutter: 900 };
        if (viewportWidth >= 750) return { baseEndGutter: 92, desiredRightGap: 40, maxEndGutter: 640 };
        return { baseEndGutter: 24, desiredRightGap: 24, maxEndGutter: 320 };
      };

      const getVisibleBounds = () => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const viewportLeft = 0;
        const viewportRight = window.innerWidth || document.documentElement.clientWidth;
        let visibleLeft = Math.max(wrapperRect.left, viewportLeft);
        let visibleRight = Math.min(wrapperRect.right, viewportRight);
        let node = wrapper.parentElement;

        while (node && node !== document.body) {
          const nodeStyles = window.getComputedStyle(node);
          if (nodeStyles.overflowX === 'hidden' || nodeStyles.overflowX === 'clip') {
            const nodeRect = node.getBoundingClientRect();
            visibleLeft = Math.max(visibleLeft, nodeRect.left);
            visibleRight = Math.min(visibleRight, nodeRect.right);
          }
          node = node.parentElement;
        }

        const clipLeftDelta = Math.max(0, visibleLeft - wrapperRect.left);
        const clipRightDelta = Math.max(clipLeftDelta, visibleRight - wrapperRect.left);
        return { clipLeftDelta, clipRightDelta };
      };

      const getLastCardMetrics = () => {
        const lastCard = track.querySelector('.lifestyle-prod-{{ section.id }}__card:last-of-type');
        if (!lastCard) return null;
        const trackOffset = track.offsetLeft;
        const cardLeft = lastCard.offsetLeft - trackOffset;
        const cardRight = cardLeft + lastCard.offsetWidth;
        return { cardLeft, cardRight };
      };

      const getEndTargetLeft = (desiredRightGap) => {
        const metrics = getLastCardMetrics();
        if (!metrics) return 0;
        const { clipRightDelta } = getVisibleBounds();
        return Math.max(0, Math.ceil(metrics.cardRight + desiredRightGap - clipRightDelta));
      };

      const calibrateEndGutter = () => {
        const tier = getTierConfig();
        let tunedEndGutter = tier.baseEndGutter;
        let attempts = 0;

        while (attempts < 4) {
          section.style.setProperty('--lifestyle-end-gutter', `${tunedEndGutter}px`);
          void wrapper.offsetWidth;

          const requiredEndTarget = getEndTargetLeft(tier.desiredRightGap);
          const maxScrollLeft = Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
          const deficit = Math.ceil(requiredEndTarget - maxScrollLeft);

          if (deficit <= 0) break;

          tunedEndGutter = Math.min(tunedEndGutter + deficit + 8, tier.maxEndGutter);
          attempts += 1;
        }

        section.style.setProperty('--lifestyle-end-gutter', `${tunedEndGutter}px`);
      };

      const cardSelector = '.lifestyle-prod-{{ section.id }}__card';
      let snapPoints = [];
      let isMouseDragging = false;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let hasDragged = false;
      let suppressClick = false;

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const getMaxScrollLeft = () => Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);

      const collectSnapPoints = () => {
        const trackOffset = track.offsetLeft;
        return Array.from(track.querySelectorAll(cardSelector)).map((card) =>
          Math.round(card.offsetLeft - trackOffset)
        );
      };

      const getNearestIndex = () => {
        if (!snapPoints.length) return 0;
        const currentLeft = wrapper.scrollLeft;
        let nearestIndex = 0;
        let nearestDistance = Math.abs(snapPoints[0] - currentLeft);

        snapPoints.forEach((point, index) => {
          const distance = Math.abs(point - currentLeft);
          if (distance < nearestDistance) {
            nearestIndex = index;
            nearestDistance = distance;
          }
        });

        return nearestIndex;
      };

      const usesMobileStepNavigation = () => window.matchMedia('(max-width: 989px)').matches;

      const getAdjacentStepIndex = (direction) => {
        if (!snapPoints.length) return 0;
        const currentLeft = wrapper.scrollLeft;
        const tolerance = 6;

        if (direction > 0) {
          for (let index = 0; index < snapPoints.length; index += 1) {
            if (snapPoints[index] > currentLeft + tolerance) return index;
          }
          return snapPoints.length - 1;
        }

        for (let index = snapPoints.length - 1; index >= 0; index -= 1) {
          if (snapPoints[index] < currentLeft - tolerance) return index;
        }
        return 0;
      };

      const updateNavState = () => {
        const tolerance = 6;

        if (usesEdgeNavigation()) {
          const maxScrollLeft = getMaxScrollLeft();
          if (prevButton) prevButton.disabled = wrapper.scrollLeft <= tolerance;
          if (nextButton) nextButton.disabled = wrapper.scrollLeft >= maxScrollLeft - tolerance;
          return;
        }

        if (!snapPoints.length) return;
        const index = getNearestIndex();
        if (prevButton) prevButton.disabled = index <= 0;
        if (nextButton) nextButton.disabled = index >= snapPoints.length - 1;
      };

      const usesEdgeNavigation = () => window.matchMedia('(min-width: 990px)').matches;

      const applySnapModeForTier = () => {
        if (usesEdgeNavigation()) {
          wrapper.style.scrollSnapType = 'x proximity';
          return;
        }
        wrapper.style.scrollSnapType = '';
      };

      const forceEdge = (toEnd) => {
        const previousSnapType = wrapper.style.scrollSnapType;
        wrapper.style.scrollSnapType = 'none';

        // Force layout so end-gutter CSS changes are reflected before jump.
        void wrapper.offsetWidth;

        const tier = getTierConfig();
        const targetLeft = toEnd
          ? clamp(getEndTargetLeft(tier.desiredRightGap), 0, getMaxScrollLeft())
          : 0;
        wrapper.scrollLeft = targetLeft;

        requestAnimationFrame(() => {
          const confirmedTargetLeft = toEnd
            ? clamp(getEndTargetLeft(tier.desiredRightGap), 0, getMaxScrollLeft())
            : 0;
          wrapper.scrollLeft = confirmedTargetLeft;
          wrapper.style.scrollSnapType = usesEdgeNavigation() ? 'x proximity' : previousSnapType;
          updateNavState();
        });
      };

      const scrollToIndex = (index) => {
        if (!snapPoints.length) return;
        const boundedIndex = clamp(index, 0, snapPoints.length - 1);
        const targetLeft = clamp(snapPoints[boundedIndex], 0, getMaxScrollLeft());
        wrapper.scrollTo({ left: targetLeft, behavior: 'smooth' });
        requestAnimationFrame(updateNavState);
      };

      const onPrevArrowClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        if (usesEdgeNavigation()) {
          forceEdge(false);
          requestAnimationFrame(() => {
            forceEdge(false);
          });
        } else {
          if (!snapPoints.length) return;
          if (usesMobileStepNavigation()) {
            scrollToIndex(getAdjacentStepIndex(-1));
          } else {
            scrollToIndex(getNearestIndex() - 1);
          }
        }
      };

      const onNextArrowClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        if (usesEdgeNavigation()) {
          calibrateEndGutter();
          forceEdge(true);
          requestAnimationFrame(() => {
            calibrateEndGutter();
            forceEdge(true);
            requestAnimationFrame(() => {
              forceEdge(true);
            });
          });
        } else {
          if (!snapPoints.length) return;
          if (usesMobileStepNavigation()) {
            scrollToIndex(getAdjacentStepIndex(1));
          } else {
            scrollToIndex(getNearestIndex() + 1);
          }
        }
      };

      const endMouseDrag = (shouldSnap = true) => {
        if (!isMouseDragging) return;
        isMouseDragging = false;
        dragPointerId = null;
        wrapper.classList.remove('is-dragging');

        if (shouldSnap && hasDragged) {
          scrollToIndex(getNearestIndex());
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }

        hasDragged = false;
        requestAnimationFrame(updateNavState);
      };

      const initializeLayout = () => {
        hasInitializedPosition = false;
        applySnapModeForTier();
        calibrateEndGutter();
        requestAnimationFrame(() => {
          alignToRight();
          snapPoints = collectSnapPoints();
          updateNavState();
          requestAnimationFrame(() => {
            alignToRight();
            snapPoints = collectSnapPoints();
            updateNavState();
          });
        });
      };

      wrapper.querySelectorAll('img').forEach((image) => {
        image.setAttribute('draggable', 'false');
      });

      const syncNavState = () => {
        requestAnimationFrame(updateNavState);
      };

      const onPointerDown = (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        isMouseDragging = true;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScrollLeft = wrapper.scrollLeft;
        hasDragged = false;
        wrapper.classList.add('is-dragging');
      };

      const onPointerMove = (event) => {
        if (!isMouseDragging || event.pointerId !== dragPointerId) return;

        const deltaX = event.clientX - dragStartX;
        if (Math.abs(deltaX) > 3) hasDragged = true;

        wrapper.scrollLeft = dragStartScrollLeft - deltaX;
        if (hasDragged) event.preventDefault();
        syncNavState();
      };

      const onPointerUp = (event) => {
        if (!isMouseDragging || event.pointerId !== dragPointerId) return;
        endMouseDrag(true);
      };

      const onPointerCancel = (event) => {
        if (!isMouseDragging || event.pointerId !== dragPointerId) return;
        endMouseDrag(false);
      };

      const onClickCapture = (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      };

      const preventNativeDrag = (event) => {
        event.preventDefault();
      };

      initializeLayout();
      bind(window, 'resize', initializeLayout);
      bind(wrapper, 'scroll', syncNavState, { passive: true });
      bind(wrapper, 'wheel', syncNavState, { passive: true });
      bind(wrapper, 'touchmove', syncNavState, { passive: true });
      bind(wrapper, 'pointerdown', onPointerDown);
      bind(window, 'pointermove', onPointerMove);
      bind(window, 'pointerup', onPointerUp);
      bind(window, 'pointercancel', onPointerCancel);
      bind(wrapper, 'click', onClickCapture, true);
      bind(wrapper, 'dragstart', preventNativeDrag);
      if (prevButton) bind(prevButton, 'click', onPrevArrowClick, true);
      if (nextButton) bind(nextButton, 'click', onNextArrowClick, true);

      track.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', initializeLayout, { once: true });
      });

      teardown = () => {
        removeHandlers.forEach((removeListener) => removeListener());
        teardown = null;
      };
    };

    mount();

    document.addEventListener('shopify:section:load', (event) => {
      if (String(event.detail && event.detail.sectionId) !== sectionId) return;
      mount();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (String(event.detail && event.detail.sectionId) !== sectionId) return;
      if (teardown) {
        teardown();
        teardown = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.__plusPouchDisclaimerAnchorBound) return;
    window.__plusPouchDisclaimerAnchorBound = true;

    const anchorIds = ['fda-disclaimer', 'site-fda-disclaimer'];
    const canonicalAnchorId = 'fda-disclaimer';
    const targetHash = `#${canonicalAnchorId}`;
    const realignDelays = [0, 120, 320, 650, 1100];

    const hasDisclaimerHash = (hashValue) => {
      if (!hashValue) return false;
      const normalized = hashValue.replace('#', '');
      return anchorIds.includes(normalized);
    };

    const getTarget = () => document.getElementById(canonicalAnchorId);
    const getDisclaimer = () => document.getElementById(canonicalAnchorId);

    const getHeaderOffset = () => {
      const stickyHeader = document.querySelector('sticky-header');
      const sectionHeader = document.querySelector('.section-header');
      const header = stickyHeader || sectionHeader;
      if (!header) return 0;
      return Math.max(header.getBoundingClientRect().height, 0);
    };

    const alignDisclaimer = (behavior) => {
      if (!hasDisclaimerHash(window.location.hash)) return;
      const target = getTarget();
      if (!target) return;

      const rect = target.getBoundingClientRect();
      const headerOffset = getHeaderOffset() + 16;
      const desiredTop = rect.top + window.scrollY - headerOffset;
      const maxScrollTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const clampedTop = Math.min(Math.max(0, desiredTop), maxScrollTop);

      window.scrollTo({ top: clampedTop, behavior });
    };

    const pulseDisclaimer = () => {
      const disclaimer = getDisclaimer();
      if (!disclaimer) return;
      disclaimer.classList.add('is-anchor-active');
      window.setTimeout(() => {
        disclaimer.classList.remove('is-anchor-active');
      }, 1400);
    };

    const scheduleRealign = (initialBehavior = 'auto') => {
      if (!hasDisclaimerHash(window.location.hash)) return;
      realignDelays.forEach((delay, index) => {
        window.setTimeout(() => {
          alignDisclaimer(index === 0 ? initialBehavior : 'auto');
        }, delay);
      });
      pulseDisclaimer();
    };

    const isLocalDisclaimerLink = (link) => {
      try {
        const linkUrl = new URL(link.href, window.location.href);
        return (
          linkUrl.origin === window.location.origin &&
          linkUrl.pathname === window.location.pathname &&
          hasDisclaimerHash(linkUrl.hash)
        );
      } catch (error) {
        return false;
      }
    };

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a[href*="#"]');
        if (!link || !isLocalDisclaimerLink(link)) return;

        event.preventDefault();
        if (window.location.hash !== targetHash) {
          window.history.pushState({}, '', targetHash);
        }
        scheduleRealign('smooth');
      },
      true
    );

    if (hasDisclaimerHash(window.location.hash)) scheduleRealign('auto');

    window.addEventListener('hashchange', () => scheduleRealign('auto'));
    window.addEventListener('load', () => scheduleRealign('auto'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('.testimonial-slider-{{ section.id }}');
    if (!section) return;

    const wrapper = section.querySelector('.testimonial-slider-{{ section.id }}__track-wrapper');
    const track = section.querySelector('.testimonial-slider-{{ section.id }}__track');
    if (!wrapper || !track) return;

    // Mouse drag support
    let isDown = false;
    let startX;
    let scrollStart;

    const getPageX = (event) => {
      if (event.touches && event.touches.length) return event.touches[0].pageX;
      return event.pageX;
    };

    const startDrag = (e) => {
      isDown = true;
      startX = getPageX(e);
      scrollStart = wrapper.scrollLeft;
    };

    const moveDrag = (e) => {
      if (!isDown) return;
      const x = getPageX(e);
      if (x == null) return;
      const walk = startX - x;
      wrapper.scrollLeft = scrollStart + walk;
    };

    const endDrag = () => {
      isDown = false;
    };

    wrapper.addEventListener('mousedown', startDrag);
    wrapper.addEventListener('touchstart', startDrag, { passive: true });
    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('touchmove', moveDrag, { passive: true });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);
    window.addEventListener('mouseleave', endDrag);
  })();

  } catch(e) { console.error(e); }
})();
})();
